import styled, { css } from 'styled-components';

import { addDesktopDesignStyle, colorUsage, fontSize, getSpacing } from 'stylesheetB2c';

export enum PLAYER_BUTTON_SIZE {
  SMALL = 0,
  MEDIUM = 1,
  BIG = 2,
}

export const PLAYER_BUTTON_SIZE_CONSTANTS = {
  [PLAYER_BUTTON_SIZE.SMALL]: {
    pixelSize: getSpacing(7),
    fontSize: fontSize.XXXLarge,
  },
  [PLAYER_BUTTON_SIZE.MEDIUM]: {
    pixelSize: getSpacing(11),
    fontSize: fontSize.giant,
  },
  [PLAYER_BUTTON_SIZE.BIG]: {
    pixelSize: getSpacing(13),
    fontSize: fontSize.XXXGiant,
  },
};

const BUTTON_DESKTOP_SIZE = getSpacing(6);

interface ButtonProps {
  mobileSize?: PLAYER_BUTTON_SIZE;
  isDisabled?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  flex-shrink: 0;
  background-color: ${colorUsage.mp3KbpPlayer.playerButtonBackground};
  ${({ mobileSize, isDisabled }) => {
    const buttonSize = mobileSize ?? PLAYER_BUTTON_SIZE.MEDIUM;
    return css`
      height: ${PLAYER_BUTTON_SIZE_CONSTANTS[buttonSize].pixelSize};
      width: ${PLAYER_BUTTON_SIZE_CONSTANTS[buttonSize].pixelSize};
      border-radius: ${PLAYER_BUTTON_SIZE_CONSTANTS[buttonSize].pixelSize};
      font-size: ${PLAYER_BUTTON_SIZE_CONSTANTS[buttonSize].fontSize};
      cursor: pointer;
      ${
        isDisabled
          ? css`
            color: ${colorUsage.mp3KbpPlayer.playerButtonIconColorDisabled};

            &:focus {
              outline: none;
            }
          `
          : css`
            color: ${colorUsage.mp3KbpPlayer.playerButtonIconColor};

            &:focus {
              outline: none;
              background-color: ${colorUsage.mp3KbpPlayer.playerButtonBackgroundHovered};
            }
            ${addDesktopDesignStyle(css`
              &:hover {
                background-color: ${colorUsage.mp3KbpPlayer.playerButtonBackgroundHovered};
                transition: background-color 0.1s;
              }
            `)}
          `
      }
    `;
  }}

  ${addDesktopDesignStyle(css`
    height: ${BUTTON_DESKTOP_SIZE};
    width: ${BUTTON_DESKTOP_SIZE};
    border-radius: ${BUTTON_DESKTOP_SIZE};
    background-color: ${colorUsage.mp3KbpPlayer.playerButtonBackground};
    transition: background-color 0.1s;
    font-size: ${fontSize.XXXLarge};
    cursor: pointer;
  `)}
`;
Button.displayName = 'PlayerButton';

export const shadowedIconStyle = {
  filter: `drop-shadow(0 0 4px ${colorUsage.mp3KbpPlayer.buttonShadowColor})`,
};
